import type { ReactNode } from 'react';

export const symbol_on_hub_device: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M351-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h258q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H351Zm-32-118-40-558q-2-20 10-32t32-12h318q20 0 32 12t10 32l-40 558q-1 12-9.39 20-8.4 8-20.61 8H349q-12.21 0-20.61-8-8.39-8-9.39-20Zm59-32h204l39-510H339l39 510Zm0-510h-39 282-243Z"
		/>
	</svg>
);
